// Globals
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';

// Components
import { GavelIcon } from '@/icons';
import { useInfiniteScroll } from '@/hooks';
import BidCard from '../BidCard/BidCard';
import { StyledBidsList, StyledHeader, StyledHeaderTitle, StyledList } from './BidsListStyles';

// Models
import { IBidItem } from '@/models/bidding.model';

interface BidsListProps {
  items: IBidItem[];
  isLoading: boolean;
  hasMore: boolean;
  onLoadMore: () => void;
  totalCount?: number;
  ownerName?: string;
  hasError?: boolean;
}

const BidsList = ({
  items,
  isLoading,
  hasMore,
  onLoadMore,
  totalCount,
  ownerName,
  hasError = false,
}: BidsListProps) => {
  const { t } = useTranslation('bidding');
  const loadMoreRef = useRef<HTMLDivElement>(null);

  useInfiniteScroll({
    callback: onLoadMore,
    ref: loadMoreRef,
    isLoading,
    hasMore,
    hasError,
    listLength: items.length,
  });

  return (
    <StyledBidsList>
      <StyledHeader>
        <StyledHeaderTitle>
          <GavelIcon />
          {t('bidding_bids_title')} ({totalCount ?? items.length})
        </StyledHeaderTitle>
      </StyledHeader>
      <StyledList>
        {items.map((item, index) => (
          <BidCard key={item.id || index} bidContext={item} ownerName={ownerName} />
        ))}
        {hasMore && <div ref={loadMoreRef} style={{ height: 1 }} />}
      </StyledList>
    </StyledBidsList>
  );
};

export default BidsList;
